export default function Transactions() {
  return <div>Transactions Screen</div>;
}
